export const environment = {
  production: false,
  apiUrl: 'https://develop.api.accelup.eu',
  environment: 'development',
  projectUploadLimit: 5,
  domain: 'develop.accelup.eu',
  googleAnalyticsId: 'G-X5ZQYBV6BX',
  reCaptchaSiteKey: '6LeG-6wpAAAAALupkfQVlRHqsigjdsE_v-hnJj85'
};
